export const SEND_INVITE_REQUESTED = 'SEND_INVITE_REQUESTED';
export const SEND_INVITE_SUCCESS = 'SEND_INVITE_SUCCESS';
export const SEND_INVITE_FAILED = 'SEND_INVITE_FAILED';

export const DELETE_INVITE_REQUESTED = 'DELETE_INVITE_REQUESTED';
export const DELETE_INVITE_SUCCESS = 'DELETE_INVITE_SUCCESS';
export const DELETE_INVITE_FAILED = 'DELETE_INVITE_FAILED';

export const DELETE_ORGANIZATION_MEMBER_REQUESTED = 'DELETE_ORGANIZATION_MEMBER_REQUESTED';
export const DELETE_ORGANIZATION_MEMBER_SUCCESS = 'DELETE_ORGANIZATION_MEMBER_SUCCESS';
export const DELETE_ORGANIZATION_MEMBER_FAILED = 'DELETE_ORGANIZATION_MEMBER_FAILED';

export const TEAM_REQUESTED = 'TEAM_REQUESTED';
export const TEAM_SUCCESS = 'TEAM_SUCCESS';
export const TEAM_FAILED = 'TEAM_FAILED';
